module.exports = __webpack_public_path__ + "static/media/COS_PHARMA_MAD.7dfe5532.jpeg";